// 协议服务
import { AgreementTypeEnum } from '@/enums/agreement-type';
import { RouteConfig } from 'vue-router';
import URLUtils from '@/shared/utils/URLUtils';
import { RouterV2Enum } from '../router-names';

export default (): RouteConfig[] => ([
  {
    path: RouterV2Enum.contractList,
    name: 'contractList',
    component: () => import(/* webpackChunkName: "contract" */ '@/views_v2/contract-list'),
    meta: {
      pageId: '臻有钱_法律条款及隐私政策',
      title: '法律条款及隐私政策',
    },
  },

  {
    path: RouterV2Enum.legalConstract,
    name: 'legalConstract',
    component: () => import(/* webpackChunkName: "contract" */ '@/views_v2/legal-contract'),
    meta: {
      pageId: 'finance_legalContract',
      title: '法律条款及隐私政策',
      needLogin: false,
    },
    beforeEnter: (to, _, next) => {
      const { isNeedLogin = '', contractType } = to.query || URLUtils.getQueryMap() || {};
      const setMeta = (to.meta) as ({ needLogin: boolean });


      if (setMeta) {
        setMeta.needLogin = isNeedLogin
          ? isNeedLogin !== 'false'
          : contractType !== String(AgreementTypeEnum.APP);
      }

      next();
    },
    props: (route) => ({
      userContract: route.query.contractType === String(AgreementTypeEnum.SERVE),
      skAppContract: route.query.contractType === String(AgreementTypeEnum.APP),
      marketContract: route.query.contractType === String(AgreementTypeEnum.MARKET),
      h5NewWebview: route.query.h5NewWebview === 'true',
      useSessionCached: route.query.useSessionCached === 'true',
      sceneType: route.query.sceneType || '',
    }),
  },

  {
    path: RouterV2Enum.cooperationChannel,
    name: 'cooperationChannel',
    component: () => import(
      /* webpackChunkName: "contract" */ '@/views_v2/cooperation-channel'
    ),
    meta: {
      pageId: 'finance_cooperationChannel',
      title: '合作渠道服务协议',
    },
  },

  {
    path: RouterV2Enum.channelConstract,
    name: 'channelConstract',
    component: () => import(
      /* webpackChunkName: "contract" */ '@/views_v2/channel-constract'
    ),
    meta: {
      pageId: 'finance_channelConstract',
      title: '合作渠道服务协议',
    },
  },
]);
